/* **************************************************** Finishing Shedule Brand */
export interface FSBrand {
    id: number;
    category: string;
    sub_category: string | null;
    brand_name: string;
    created_by: number | null;
}

export const mapFSBrand = (data: any): FSBrand => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBrand = {
        id: data.id,
        category: data.category,
        sub_category: data.sub_category || null,
        brand_name: data.brand_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSBrands = (data: any[]): FSBrand[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBrand);
};
